export default {"src":"/_next/static/media/techpoint.1cbb848a.svg","height":27,"width":92,"blurWidth":0,"blurHeight":0};